/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class HorribleHeroesGameAssets {
    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static MAIN_GAME_BACKGROUND_FS: string = "mainFSBackGround";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("waysFont", "fonts/bitmapfonts/waysFont.fnt"),
                ]
            }
        ],
        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ],
                animations: {
                    "counter": "ui/counter",
                    "Smoke_LT": "BG_FS_mode/Smoke_LT/Smoke_LT_",
                    "highlightX": "x",
                    "winToggle": "win_toggle/win_toggle_",
                    "quoteBgSprite": "quoteBg",
                    "commonOverlay": "Common_overlay/Common_overlay_",
                    "bgForeground": "Bg_foreground",
                    "reelArea": "reelArea"
                }
            },
            {
                name: "mainGreenYellow",
                assets: [
                    new TextureAsset("mainGreenYellow0", "sheets/mainGreenYellow/mainGreenYellow0.json"),
                ],
                animations: {
                    "Smoke_LT": "BG_FS_mode/Smoke_LT/Smoke_LT_",
                    "X2": "X2",
                    "X3": "X3",
                    "MX2": "Mayhem multipliers/X2",
                    "MX3": "Mayhem multipliers/X3",
                    "revealAnimationX2_5": "xwaysAnimation/melt_Base Xways/x2_144x235/x2_144x235_half_",
                    "revealAnimationX3_6": "xwaysAnimation/melt_Base Xways/x3_144x294/x3_144x294_",
                    "revealInfAnimX2_5": "xwaysAnimation/melt_infectious Xways/x2_144x235/x2_144x235_",
                    "revealInfAnimX2_6": "xwaysAnimation/melt_infectious Xways/x2_144x196/x2_144x196_",
                    "revealInfAnimX3_6": "xwaysAnimation/melt_infectious Xways/x3_144x294/x3_144x294_",
                    "revealInfAnimX3_8": "xwaysAnimation/melt_infectious Xways/x3_144x220/x3_144x220_",
                    "WildTrail": "Trail_wild_Xways_sym/wild_trail",
                    "XTrail": "Trail_wild_Xways_sym/Xways_trail",
                    "capWinX": "Test_wincap_countup"
                }
            },
            { //not to be compressed  by tinypng
                name: "highQualityPng",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("highQualityPng0", "sheets/highQualityPng/highQualityPng0.json")
                ],
                animations: {
                    "ways": "ways",
                    "cloud_0": "bg_idle/Cloud_1",
                    "way": "way",
                    "winPotential": "win_potential_1/win_potential_",
                }
            },
            {
                name: "bigWin",
                assets: [
                    new TextureAsset("bigWin0", "sheets/bigWin/bigWin0.json"),
                    new TextureAsset("bigWin1", "sheets/bigWin/bigWin1.json")
                ],
                animations: {
                    "bigWinCoin1": "gem_blue/gem_blue_",
                    "bigWinCoin0": "gem_long/",
                    "bigWinCoin2": "gem_round/gem_round_"
                }
            },
            {
                name: "mainRed",
                assets: [
                    new TextureAsset("mainRed0", "sheets/mainRed/mainRed0.json")
                ]
            },
            {//not to be compressed  by tinypng
                name: "bigWinHigh",
                assets: [
                    new TextureAsset("bigWinHigh0", "sheets/bigWinHigh/bigWinHigh0.json")
                ]
            },
            {
                name: "mayhemMeter",
                assets: [
                    new TextureAsset("mayhemMeter0", "sheets/mayhemMeter/mayhemMeter0.json")
                ]
            },
            {
                name: "mayhemMeterRed",
                assets: [
                    new TextureAsset("mayhemMeterRed0", "sheets/mayhemMeterRed/mayhemMeterRed0.json")
                ]
            },
            // #496 -> we need this in high quality only, no need to load other quality level even in low, since we want it high there too.
            {
                name: "mainHigh",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json")
                ]
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                    new TextureAsset("freespin1", "sheets/freespin/freespin1.json")
                ],
                animations: {
                    "wildLock": "fs_pick_screen/wild_lock_highlight",
                    "bar": "fs_pick_screen/bar",
                    "chainFS": "bg/chainFS"
                }
            },
            {
                name: "freeSpinYellow",
                assets: [
                    new TextureAsset("freeSpinYellow0", "sheets/freeSpinYellow/freeSpinYellow0.json")
                ],
                animations: {
                    "leftMetalAsset": "bg/Left_metal_asset",
                    "fsBar": "bg/fsBar"
                }
            },
            {//not to be compressed  by tinypng
                name: "freeSpinHigh",
                assets: [
                    new TextureAsset("freeSpinHigh0", "sheets/freeSpinHigh/freeSpinHigh0.json")
                ]
            },
            {//not to be compressed  by tinypng
                name: "highQualityJpeg",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("highQualityJpeg", "sheets/highQualityJpeg/highQualityJpeg0.json")
                ],
                animations: {
                    "L_bg": "L_bg/Low_Sym_BG",
                    "M1_bg": "M_bg/M1_BG",
                    "M2_bg": "M_bg/M2_BG",
                    "M3_bg": "M_bg/M3_BG",
                    "M4_bg": "M_bg/M4_BG",
                    "M5_bg": "M_bg/M5_BG",
                    "MX_bg": "M_bg/MX_BG",
                    "X_bg": "X/X_BG",
                    "X_Gbg": "X/X_BG_Green",
                    "X_mayhem": "X/X_mayhem"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json")
                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "mainFSBackGround": "mainFSBackGround",
                    "xwaysMeter": "Xways_Meter/xways_meter",
                    "blue_thunder": "xwaysAnimation/blue_thunder/blue_thunder_",
                    "x_saber": "xwaysAnimation/x_saber1/x_saber_",
                    "fire": "Base_anticipation/fire/fire_",
                    "side_spark": "Base_anticipation/side_spark/side_spark_",
                    "fireParticles": "BG_Animation_Freespin mode/particles/particles_",
                    "backRainDrop": "BG_Animation_Freespin mode/Rain/Back_Rain",
                    "frontRainDrop": "BG_Animation_Freespin mode/Rain/Front_Rain",
                    "middleRainDrop": "BG_Animation_Freespin mode/Rain/Middle_Rain",
                    "lightning": "BG_Animation_Freespin mode/Lightning/Lightning_",
                    "fountainBgJpgSeq": "bigWin/effect_loop_jpeg/effect_loop_",
                    "antiLoop": "x ways_landing/anti_loop/anti_loop_",
                    "antiStrike": "S/anti_strike/anti_strike_",
                    "wildStrokeText": "Random_wild/w_stroke/w_stroke_",
                    "greenOverlay": "Random_wild/green_overlay/green_overlay_",
                    "winCapFirework": "win_cap/win_cap_firework/firework_",
                    "winCapSparkle": "win_cap/win_cap_spark/win_cap_spark_"
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("mxLand", "Spine/mx_landing.json"),
                    new SpineAsset("mayhemMeterDesktop", "Spine/mayhem_meter/mayhem_meter_desktop.json"),
                    new SpineAsset("mayhemMeterDesktopBlast", "Spine/mayhem_meter/mayhem_meter_desktop_blast.json"),
                    new SpineAsset("mayhemMeterMobile", "Spine/mayhem_meter/mayhem_meter_mobile.json"),
                    new SpineAsset("mayhemMeterMobileBlast", "Spine/mayhem_meter/mayhem_meter_mobile_blast.json"),
                    new SpineAsset("wildlanding", "Spine/wild_landing.json"),
                    new SpineAsset("fs_loadSmoke", "Spine/fs_pick_screen/fs_load_smoke_loop.json"),
                    new SpineAsset("fs_load", "Spine/fs_pick_screen/fs_load.json"),
                    new SpineAsset("fs_loadFSNumber", "Spine/fs_pick_screen/fs_load_fs_number.json"),
                    new SpineAsset("fs_loadMayhem", "Spine/fs_pick_screen/fs_load_mayhem.json"),
                    new SpineAsset("fs_ToxicSmoke", "Spine/fs_pick_screen/fs_toxic_smoke_loop.json"),
                    new SpineAsset("fs_Toxic", "Spine/fs_pick_screen/fs_toxic.json"),
                    new SpineAsset("fs_ToxicFSNumber", "Spine/fs_pick_screen/fs_toxic_fs_number.json"),
                    new SpineAsset("fs_ToxicMayhem", "Spine/fs_pick_screen/fs_toxic_mayhem.json"),
                    new SpineAsset("Sland", "Spine/bonus.json"),
                    new SpineAsset("scatterPlusOne", "Spine/fs_plus_ani.json"),
                    new SpineAsset("bigwinTransitionEffect", "Spine/bigwin_transition_effect.json"),
                    new SpineAsset("bigwinAnimation", "Spine/bigWins.json"),
                    new SpineAsset("fsOutro", "Spine/Fs_outro.json"),
                    new SpineAsset("bg_idle_fire", "Spine/bg_idle_fire.json"),
                    new SpineAsset("bg_idle_chains", "Spine/bg_idle_chains.json"),
                    new SpineAsset("countupEffect", "Spine/Countup_win_effect.json"),
                    new SpineAsset("countup", "Spine/Countup_medium_large.json"),
                    new SpineAsset("stickyWildSpine", "Spine/fs_wild_lock.json"),
                    new SpineAsset("fsintroTransitionFirespark", "Spine/bg_fg_transitionFirespark.json"),
                    new SpineAsset("fsintroTransition", "Spine/bg_fg_transition.json"),
                    new SpineAsset("fsintroTransitionMayhem", "Spine/bg_fg_transition_mayhem.json"),
                    new SpineAsset("heroesIntroSpine", "Spine/Intro_Heroes.json"),
                    new SpineAsset("Single_Chain", "Spine/Chains/Single_Chain.json"),
                    new SpineAsset("Bottom_Portrait", "Spine/Chains/Single_Chain_Bottom.json"),
                    new SpineAsset("Back_Chians", "Spine/Chains/Back_Chians.json"),
                    new SpineAsset("Rt_Top_Chain", "Spine/Chains/Rt_Top_Chain.json"),
                    new SpineAsset("Front_Chains", "Spine/Chains/Front_Chains.json"),
                    new SpineAsset("wildMult", "Spine/wild_x2_x3.json"),
                    new SpineAsset("failFsOutro", "Spine/fail_fs_outro.json"),
                    new SpineAsset("fsOutroDoorSmoke", "Spine/fs_outro_door_smoke.json"),
                    new SpineAsset("bigWinLevel5Center", "Spine/5th_bigwin/bigwin_5th_center.json"),
                    new SpineAsset("bigWinLevel5ChainLeft", "Spine/5th_bigwin/bigwin_5th_chain_l.json"),
                    new SpineAsset("bigWinLevel5ChainRight", "Spine/5th_bigwin/bigwin_5th_chain_r.json"),
                    new SpineAsset("bigWinLevel5FanSkull", "Spine/5th_bigwin/bigwin_5th_fan_skull.json"),
                    new SpineAsset("bigWinLevel5Splatter", "Spine/5th_bigwin/bigwin_5th_splatter.json"),
                    new SpineAsset("bigWinLevel5StripTop", "Spine/5th_bigwin/bigwin_5th_strip_top.json"),
                    new SpineAsset("bigWinLevel5StripBottom", "Spine/5th_bigwin/bigwin_5th_strip_bottom.json"),
                    new SpineAsset("bigWinLevel5Warning", "Spine/5th_bigwin/bigwin_5th_warning.json"),
                    new SpineAsset("randomWildEdge", "Spine/random_wild/rw_edge_loop.json"),
                    new SpineAsset("mayhemIntro", "Spine/mayhem_char.json"),
                    new SpineAsset("toxic_sign", "Spine/mayhem_signs/toxic_sign.json"),
                    new SpineAsset("mayhem_sign", "Spine/mayhem_signs/mayhem_sign.json"),
                    new SpineAsset("load_sign", "Spine/mayhem_signs/lock_n_load_sign.json"),
                    new SpineAsset("winCapStripBottom", "Spine/win_cap/win_cap_strip1.json"),
                    new SpineAsset("winCapStripTop", "Spine/win_cap/win_cap_strip2.json"),
                    new SpineAsset("winCap", "Spine/win_cap/win_cap.json")
                ]
            },
            {
                name: "symbolsBlur",
                assets: [
                    new TextureAsset("symbolsBlur0", "sheets/symbolsBlur/symbolsBlur0.json")
                ]
            },
            {
                name: "symbolHigh",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolHigh0", "sheets/symbolHigh/symbolHigh0.json")
                ],
                animations: {
                    "M1": "layers/M1",
                    "M3": "layers/M3",
                    "M5": "layers/M5",
                    "M2": "layers/M2",
                    "M4": "layers/M4",
                    "S_bottom": "S/bottom",
                    "S_left": "S/left",
                    "S_right": "S/right",
                    "S_top": "S/top",

                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "M_left": "M_Frame/Left",
                    "M_top": "M_Frame/Top",
                    "X_top": "X_Frame/Top",
                    "X_left": "X_Frame/Left",
                    "L1": "layers/L1",
                    "L2": "layers/L2",
                    "S": "layers/S"
                }
            },
            {
                name: "symbolsHighGreenYellow",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsHighGreenYellow0", "sheets/symbolsHighGreenYellow/symbolsHighGreenYellow0.json")
                ],
                animations: {
                    "L3": "layers/L3",
                    "L4": "layers/L4",
                    "L5": "layers/L5",
                    "MX": "layers/MX",
                    "W": "layers/W",
                    "X": "layers/X",
                    "W2": "layers/W_static",
                    "MX_top": "MX_Frame/top",
                    "MX_left": "MX_Frame/left",
                    "Multiplier2": "X_Frame/2",
                    "Multiplier3": "X_Frame/3",
                    "sw_4": "W_locked/W_4",
                    "sw_5": "W_locked/W_5",
                    "sw_6": "W_locked/W_6",
                    "sw_7": "W_locked/W_7",
                    "sw_8": "W_locked/W_8",
                    "wm_2": "W_locked/X2",
                    "wm_3": "W_locked/X3",
                    "S_bg": "S/BG",
                    "W_bg": "W/BG",
                    "W_bottom": "W/Bottom",
                    "W_left": "W/left",
                    "W_right": "W/right",
                    "W_top": "W/Top",
                    "W_globes": "W/Globes",
                }
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        let symFileName = symbolName;

        if (symbolName.indexOf("_") > -1) {
            symFileName = symbolName.split('_')[0];
        }

        if (stateName == null || stateName == "" || symbolName == "S" || symbolName == "W" || symbolName == "MX") {
            if (stateName == "spin") {
                return symbolName + "/" + symbolName + "_" + stateName;
            }
            return "L1" + "/" + "L1";//default blank spirite
        }
        return symFileName + "/" + symFileName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(HorribleHeroesGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
}
